"use client";

import { Container } from "@mui/material";
import { theme } from "@/lib/theme";

interface PageContainerProps {
  children: React.ReactNode;
}

export const PageContainer = ({ children }: PageContainerProps) => {
  return (
    <Container
      maxWidth={false}
      sx={{
        maxWidth: theme.containerWidth.page,
        paddingX: { xs: 1, sm: 3 }, // 8px mobile, 24px desktop
      }}
    >
      {children}
    </Container>
  );
};
